import { RELICS, RELIC_CATEGORY_WEIGHTS, RELIC_CHEST_WEIGHTS } from './relics';
import { selectWeightedRelic } from './relicBalance';

export const isShopRelic = (id) =>
  !!RELICS[id] && !RELICS[id].deprecated && RELICS[id].category !== 'Special';
export const isChestRelic = (id) =>
  !!RELICS[id] &&
  !RELICS[id].deprecated &&
  RELIC_CHEST_WEIGHTS[RELICS[id].category] > 0;

// Draw the category first, so catalog size and within-category item weights
// cannot change the advertised rarity odds. Exhausted categories renormalize.
export const drawRelicFromPool = (
  pool,
  weights = RELIC_CATEGORY_WEIGHTS,
  random = Math.random
) => {
  const categories = Object.entries(weights)
    .map(([category, weight]) => ({
      weight,
      pool: pool.filter((id) => RELICS[id]?.category === category),
    }))
    .filter((entry) => entry.weight > 0 && entry.pool.length);
  if (!categories.length) return null;
  const total = categories.reduce((sum, entry) => sum + entry.weight, 0);
  let pick = Math.max(0, Math.min(0.999999999999, random())) * total;
  for (const category of categories) {
    pick -= category.weight;
    if (pick < 0) return selectWeightedRelic(category.pool, RELICS, random);
  }
  return selectWeightedRelic(
    categories[categories.length - 1].pool,
    RELICS,
    random
  );
};
